import { render, staticRenderFns } from "./overStandard.vue?vue&type=template&id=39606b54&scoped=true&"
import script from "./overStandard.vue?vue&type=script&lang=js&"
export * from "./overStandard.vue?vue&type=script&lang=js&"
import style0 from "./overStandard.vue?vue&type=style&index=0&id=39606b54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39606b54",
  null
  
)

export default component.exports